import { createSlice } from "@reduxjs/toolkit";

export const DisplayAlertRefreshInValidSlice = createSlice({
  name: "DisplayAlertRefreshInValidSlice",
  initialState: {
    displayAlert: false,
  },
  reducers: {
    setDisplayAlertForRefreshInValid: (state) => {
      state.displayAlert = true;
    },
    setDefaultRefreshAlert: (state) => {
      state.displayAlert = false;
    },
  },
});
export const { setDisplayAlertForRefreshInValid, setDefaultRefreshAlert } =
  DisplayAlertRefreshInValidSlice.actions;

export default DisplayAlertRefreshInValidSlice.reducer;
